export let BusinessPropertyName = /*#__PURE__*/function (BusinessPropertyName) {
  BusinessPropertyName["CANCELLATION_POLICY"] = "cancellationPolicy";
  BusinessPropertyName["DEFAULT_TIMEZONE"] = "defaultTimezone";
  BusinessPropertyName["CLIENT_CAN_CHANGE_TIMEZONE"] = "clientCanChangeTimezone";
  BusinessPropertyName["MULTI_SERVICES_APPOINTMENTS"] = "isMultiServicesAppointmentsEnable";
  BusinessPropertyName["IS_CART_ENABLED"] = "isCartEnabled";
  return BusinessPropertyName;
}({});
const isGetAggregatedInfoResponse = businessResponse => {
  return 'infoView' in businessResponse;
};
export const getCustomProperties = businessResponse => {
  var _businessResponse$bus;
  return isGetAggregatedInfoResponse(businessResponse) ? businessResponse.customProperties || [] : ((_businessResponse$bus = businessResponse.businessProperties) == null ? void 0 : _businessResponse$bus.customProperties) || [];
};
export const getBusinessInfo = businessResponse => isGetAggregatedInfoResponse(businessResponse) ? businessResponse.infoView : businessResponse.info;
export const getPropertyValue = (businessResponse, propertyName) => {
  var _getCustomProperties$;
  return (_getCustomProperties$ = getCustomProperties(businessResponse).find(businessProperty => businessProperty.propertyName === propertyName)) == null ? void 0 : _getCustomProperties$.value;
};
export const isPropertyEnabled = function (businessResponse, propertyName, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }
  const value = getPropertyValue(businessResponse, propertyName);
  return value ? value === 'true' : defaultValue;
};
export const getCountryCode = businessResponse => {
  var _getBusinessInfo;
  return (_getBusinessInfo = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo.countryCode;
};
export const getTimeZone = businessResponse => {
  var _getBusinessInfo2;
  return (_getBusinessInfo2 = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo2.timeZone;
};
export const getBusinessName = businessResponse => {
  var _getBusinessInfo3;
  return (_getBusinessInfo3 = getBusinessInfo(businessResponse)) == null ? void 0 : _getBusinessInfo3.name;
};
export const getBusinessDefaultTimezone = businessResponse => {
  return getPropertyValue(businessResponse, BusinessPropertyName.DEFAULT_TIMEZONE);
};
export const canClientChangeTimezone = businessResponse => isPropertyEnabled(businessResponse, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE, true);
//# sourceMappingURL=businessInfo.js.map